import * as Styled from './styles'


export const Footer = ()=>{

    return(
        <Styled.Footer>
            <p>By Luiz Fernando</p>
            <p>API from TheMovieDB</p>
            <p>Imagens and layouts from Netflix</p>
        </Styled.Footer>
    )
}